"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Analyte = void 0;
var Analyte = /** @class */ (function () {
    function Analyte() {
    }
    return Analyte;
}());
exports.Analyte = Analyte;
//# sourceMappingURL=Analyte.js.map